<script lang="ts" setup></script>

<template>
  <svg
    id="Zakladniprvky_Sipka_Dropdown"
    xmlns="http://www.w3.org/2000/svg"
    width="7.809"
    height="10"
    viewBox="0 0 7.809 10"
  >
    <g id="Group_1308" data-name="Group 1308" transform="translate(0 10)">
      <g id="Group_5" data-name="Group 5" transform="translate(3.905 -10)">
        <path
          id="Path_11"
          data-name="Path 11"
          d="M0,0V6.266"
          fill="none"
          stroke="#000"
          stroke-width="1"
        />
      </g>
    </g>
    <g id="Group_7" data-name="Group 7" transform="translate(0 5.801)">
      <path id="Path_13" data-name="Path 13" d="M0,0,3.9,4.2,7.809,0Z" />
    </g>
  </svg>
</template>
